import './styles.css'
import React, { useState, FormEvent, ChangeEvent, useEffect } from 'react'
import { useAuth } from '../../../../contexts/auth'
import { loadReCaptcha } from 'react-recaptcha-v3'
import { Helmet } from 'react-helmet'
import CryptoJS from 'crypto-js'
import InputMask from 'react-input-mask'

import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.min.css'

import nextLogo from '../../../../assets/logo.png'

import api from '../../../../services/api'
import { Link, useParams } from 'react-router-dom'
import logoPB from '../../../../assets/images/logo-dark-1_a.svg'
import WarningLogin from '../../../../components/Warning/warningLogin'
import { ReCaptcha } from 'react-recaptcha-v3'
import ExpeditionOverview from '../../../../components/expeditionOverview/Index'
import CookieConsent from 'react-cookie-consent'
import { ImCancelCircle } from 'react-icons/im'
import ModalUserTerm from '../../../../components/ModalUserTerm'
import Draft, { convertFromHTML } from 'draft-js'
import { useWindowLocationHost } from '../../../../hooks/useWindowLocationHost'

import { CompanyApi } from '../../../../domain'
import { TransferCompanyModal } from './components/TransferCompanyModal'

interface RouteParams {
  encryptedDriverCpf: string
  encryptedDriverBirthdate: string
}

export function DriverLogin() {
  const EditorState = Draft.EditorState
  const ContentState = Draft.ContentState

  const { windowLocationHost } = useWindowLocationHost()

  const { encryptedDriverCpf, encryptedDriverBirthdate } =
    useParams<RouteParams>()

  const driverCpf = encryptedDriverCpf
    ? CryptoJS.AES.decrypt(
        encryptedDriverCpf
          .toString()
          .replaceAll('xMl3Jk', '+')
          .replaceAll('Por21Ld', '/')
          .replaceAll('Ml32', '='),
        'SecretCpf'
      ).toString(CryptoJS.enc.Utf8)
    : ''
  const driverBirthdate = encryptedDriverBirthdate
    ? CryptoJS.AES.decrypt(
        encryptedDriverBirthdate
          .toString()
          .replaceAll('xMl3Jk', '+')
          .replaceAll('Por21Ld', '/')
          .replaceAll('Ml32', '='),
        'SecretBirthdate'
      ).toString(CryptoJS.enc.Utf8)
    : ''
  const alreadyLogged = sessionStorage.getItem('@App:logged')

  const [title, setTitle] = useState<string>('')
  const [loginEnabled, setLoginEnabled] = useState<boolean>(true)
  const [cpf, setCpf] = useState<string>(driverCpf)
  const [birthDate, setBirthday] = useState<string>(driverBirthdate)
  const [loading, setLoading] = useState<boolean>(false)
  const [recaptcha, setRecaptcha] = useState<string>('')
  const [driver, setDriver] = useState<any>('')

  const [company, setCompany] = useState<CompanyApi>()
  const [altCompany, setAltCompany] = useState<CompanyApi>()
  const [companys, setCompanys] = useState<CompanyApi[]>()
  const driverCompanyId = sessionStorage.getItem('@AppDriver:companyId')
  const [attendance, setAttendance] = useState<any>()
  const { driverLogin } = useAuth()
  const [modal, setModal] = useState('')
  const [close, setClose] = useState('')
  const [modalSuspend, setModalSuspend] = useState<any>(false)

  const [tokenModal, setTokenModal] = useState<string>('')
  const [numberCode, setNumberCode] = useState<string>('')
  const [queueDate, setQueueDate] = useState<string>('')

  const [id, setId] = useState(
    Number(sessionStorage.getItem('@App:id')?.replace(/"/g, ''))
  )
  const [editorState, setEditorState] = useState(() =>
    EditorState.createWithContent(ContentState.createFromText(''))
  )

  useEffect(() => {
    setNumberCode(tokenGenerate())

    api.get(`/settings/operating-data/${driverCompanyId}`).then(response => {
      let start = response.data.settings.start
      let end = response.data.settings.end
      let weekDays = JSON.parse(response.data.settings.weekDays)
      weekDays = Object.values(weekDays)

      let week = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']

      let selectedDays = week.filter((item: any, index: number) => {
        if (weekDays[index] === true) {
          return week[index]
        }

        return ''
      })

      api
        .get(`/attendances/today/company/${driverCompanyId}`)
        .then(response => {
          setAttendance({
            attendance:
              response.data?.id && response.data?.status ? response.data.id : 0,
            attendanceStart: start,
            attendanceEnd: end,
            days: selectedDays
          })
          localStorage.setItem(
            '@AppDriver:attendance',
            JSON.stringify({
              attendance:
                response.data?.id && response.data?.status
                  ? response.data.id
                  : 0,
              attendanceStart: start,
              attendanceEnd: end,
              days: selectedDays
            })
          )
        })
    })

    setLoginEnabled(true)

    loadReCaptcha('6LdcCZ4dAAAAAJM6_yCOqvahBvE5w8c14HMQbMJS')

    api
      .get(`/company/host/`, {
        params: {
          host: windowLocationHost
        }
      })
      .then(response => {
        setCompany(response.data)

        if (!response.data) {
          api.get(`/company`).then(response => {
            setCompanys(response.data)
          })
        }
        api.get(`/useTerm/user/company/${response.data.id}`).then(response => {
          if (response.data?.content) {
            setTitle(response.data?.tile)
            const blocksFromHTML = convertFromHTML(response.data?.content)
            const state = ContentState.createFromBlockArray(
              blocksFromHTML.contentBlocks,
              blocksFromHTML.entityMap
            )

            setEditorState(EditorState.createWithContent(state))
          }
        })
      })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  async function handleSubmit(event: FormEvent) {
    event.preventDefault()
    const _birthDate = birthDate.split('/')
    setLoading(true)

    await driverLogin({
      cpf: cpf,
      company: {
        id: company?.id
      },
      birthDate: _birthDate[2] + '-' + _birthDate[1] + '-' + _birthDate[0],
      recaptcha_token: recaptcha
    })
      .then(() => {
        let companyId = sessionStorage.getItem('@App:temporaryCompanyId')
        let driverId = sessionStorage.getItem('@App:temporaryDriverId')

        api
          .get(
            `/useTerm/user/company/${Number(
              sessionStorage.getItem('@AppDriver:companyId')
            )}`
          )
          .then(response => {
            if (companyId && driverId && response.data.content) {
              window.location.assign(
                `/aprovar-termo/empresa/${companyId}/${driverId}`
              )
            } else {
              window.location.assign(`/`)
            }
          })
      })
      .catch(e => {
        if (
          e?.response?.data?.message ===
          'Usuário bloqueado, fale com o administrador do sistema!'
        ) {
          toast.error(
            `Usuário bloqueado, fale com o administrador do sistema!`,
            { autoClose: 10000 }
          )
        } else if (e?.response?.status === 406) {
          setAltCompany(e?.response?.data?.company_a)
          setDriver(e?.response?.data?.driver)
          setModalSuspend(true)
          setQueueDate(e?.response?.data?.company_a?.queue?.date)
        } else if (e?.response?.status === 409) {
          toast.error(e?.response?.data?.message)
        } else {
          toast.error('Usuário ou senha inválido')
        }

        setLoading(false)
      })
  }

  function handleCloseModal() {
    hideModal()
  }

  function handleCorfirmDelete() {
    showModal()
    setId(id)
  }

  const showModal = () => {
    setModal('show')
  }

  const hideModal = () => {
    setModal('')
  }

  const verifyCallback = (recaptchaToken: any) => {
    setRecaptcha(recaptchaToken)
  }

  function handleLoginChange(event: ChangeEvent<HTMLInputElement>) {
    setCpf(event.target.value)
  }

  function handlePassChange(event: ChangeEvent<HTMLInputElement>) {
    setBirthday(event.target.value)
  }

  function tokenGenerate() {
    const numberCode = Math.floor(Math.random() * 9999) + 1000
    return numberCode.toString()
  }
  function handleTokenChange(event: ChangeEvent<HTMLInputElement>) {
    setTokenModal(event.target.value)
  }

  function handleAccept() {
    document.cookie = 'userTerm=accepted'
  }

  return (
    <>
      {loginEnabled === true ? (
        <div className='login driver mobile'>
          <Helmet>
            <title>Login | Motorista</title>
            <meta
              name='description'
              content='NextCargo Controle de Expedição'
            />
          </Helmet>

          <ModalUserTerm
            type='Termo'
            id={id}
            title={title}
            className={modal}
            handleClose={handleCloseModal}
            editorState={editorState}
          />

          <div className='container'>
            {driverCompanyId !== null && (
              <ExpeditionOverview attendance={attendance} />
            )}

            <div className='logo'>
              <img
                src={
                  company?.logo
                    ? `${process.env.REACT_APP_API}/${company?.logo}`
                    : nextLogo
                }
                alt=''
              />
            </div>

            {/* <WarningLogin /> */}
            {company && (
              <div className='data'>
                <div className='login-box'>
                  <h1>Login</h1>
                  <form onSubmit={handleSubmit}>
                    <InputMask
                      mask='999.999.999-99'
                      type='cpf'
                      name='cpf'
                      placeholder='CPF'
                      value={cpf}
                      onChange={handleLoginChange}
                    />
                    <InputMask
                      mask='99/99/9999'
                      name='birthDate'
                      placeholder='Data Nascimento'
                      value={birthDate}
                      onChange={handlePassChange}
                    />

                    <button
                      id='button-login'
                      type='submit'
                      className='btn btn-primary btn-block btn-large'
                    >
                      {loading ? 'Carregando...' : 'Entrar'}
                    </button>
                  </form>
                  <div className='nova-conta'>
                    <Link to={`/app/driver/novo/${company?.id}`}>
                      Não possui cadastro ? Clique aqui.
                    </Link>
                  </div>
                  <div className='privacy-policy '>
                    <button
                      onClick={() => {
                        handleCorfirmDelete()
                      }}
                      className='settings'
                    >
                      {alreadyLogged !== 'true'
                        ? 'Leia nossa politica de Privacidade e Termos de Uso'
                        : 'Politica de Privacidade e Termos de Uso'}
                    </button>
                  </div>
                </div>
                <div className='logo'>
                  <img
                    src={
                      company?.logo
                        ? `${process.env.REACT_APP_API}/${company?.logo}`
                        : nextLogo
                    }
                    alt=''
                  />
                </div>
              </div>
            )}

            {companys && (
              <div className='company-menu'>
                <div className='company-title'>
                  <h1>Selecione uma empresa: </h1>
                </div>
                <div className='company-buttom'>
                  {companys?.map((item: CompanyApi) => {
                    return (
                      <div className='company-item' key={item.id}>
                        <a href={item.website}>
                          <button>
                            {item.company?.slice(0, 16).toUpperCase()}
                          </button>
                        </a>
                      </div>
                    )
                  })}
                </div>
                <div className='logo'>
                  <img
                    src={
                      company?.logo
                        ? `${process.env.REACT_APP_API}/${company?.logo}`
                        : nextLogo
                    }
                    alt=''
                  />
                </div>
              </div>
            )}
          </div>

          <div className='powerBy'>
            <div>Powered by</div>
            <div>
              <img style={{ width: 170, marginTop: 10 }} src={logoPB} alt='' />
            </div>
          </div>

          {company && !document.cookie.match('userTerm') && (
            <div className={close + ''}>
              <CookieConsent
                location='bottom'
                buttonText=''
                cookieName='acceptedUseTerm'
                buttonStyle={{
                  color: '#dedede',
                  backgroundColor: '#fff',
                  fontSize: '13px'
                }}
                expires={150}
              >
                <div className='title'>
                  <div>
                    Usamos cookies para personalizar conteúdos e melhorar a sua
                    experiência
                  </div>
                </div>
                <div className='body'>
                  <div>
                    Usamos cookies para personalizar conteúdos e melhorar a sua
                    experiência
                  </div>
                  <button
                    onClick={() => {
                      handleCorfirmDelete()
                    }}
                    className='settings'
                  >
                    Leia nossa politica de Privacidade e Termos de Uso{' '}
                  </button>
                  <button
                    onClick={() => {
                      handleAccept()
                      setClose('none')
                    }}
                    className='send'
                  >
                    Entendi e aceito
                  </button>
                  <button
                    onClick={() => {
                      setClose('none')
                    }}
                    className='close'
                  >
                    <ImCancelCircle />
                  </button>
                </div>
              </CookieConsent>
            </div>
          )}

          <ReCaptcha
            sitekey={'6LdcCZ4dAAAAAJM6_yCOqvahBvE5w8c14HMQbMJS'}
            action='action_name'
            verifyCallback={verifyCallback}
          />

          <TransferCompanyModal
            open={modalSuspend}
            setOpen={() => setModalSuspend(false)}
            driver={driver}
            company={company}
            altCompany={altCompany}
            numberCode={numberCode}
            queueDate={queueDate}
            tokenModal={tokenModal}
            handleTokenChange={handleTokenChange}
            onSuccess={handleSubmit}
          />
        </div>
      ) : (
        <>
          <WarningLogin />
        </>
      )}
    </>
  )
}
